<template>
  <div v-on:keyup.enter="onEnter">
    <b-sidebar id="sidebar-1" ref="refSidebar" :title="title" right shadow backdrop-variant="white" variant="white" backdrop>
      <template #footer>
        <div style="gap: .5rem; justify-content: space-between"
          class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <button type="button" class="btn rounded-4 btn-third" @click="$emit('submit')">
            <i class="fas fa-search"></i>
            Filtrar
          </button>
          <button type="button" class="btn rounded-4 btn-default w-100" @click="$emit('clear')">
            <i class="fas fa-trash-alt"></i>
            Limpar Filtros
          </button>
        </div>
      </template>
      <div class="search__body__container">
        <slot>
        </slot>
      </div>
    </b-sidebar>
  </div>
</template>
<script>

export default {
  name: 'NxSearch',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Pesquisar'
    }
  },
  methods: {
    onEnter () {
      this.$emit('submit')
      this.$refs.refSidebar.hide()
    }
  }
}
</script>
<style lang="scss">
.b-sidebar#sidebar-1 {
  top: 3.5rem;
  height: calc(100vh - 3.5rem);
}

.search__body {
  &__container {
    padding: 0 2rem 1rem 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/sidebars/SidebarSearch.vue